<ng-template #template>
    <div class="ant-notification-notice-content">
        <div class="ant-notification-notice-with-icon">
            @if (icon()) {
                <span class="ant-notification-notice-icon p4">
                    <i nz-icon><adspt-icon [name]="icon()" /></i
                ></span>
            }
            <div class="ant-notification-notice-message">
                <p class="p4">{{ title() }}</p>
            </div>
        </div>
    </div>
</ng-template>
